import { RouteConfig } from 'vue-router'
import UserProfileLayout from '@/views/layouts/UserProfileLayout.vue'
import Achievement from '@/views/userProfile/Achievement.vue'
import Career from '@/views/userProfile/Career.vue'
import PersonalInfo from '@/views/userProfile/PersonalInfo.vue'
import Privacy from '@/views/userProfile/Privacy.vue'
import ProfileVisibility from '@/views/userProfile/ProfileVisibility.vue'
import Security from '@/views/userProfile/Security.vue'
import WorkEducation from '@/views/userProfile/WorkEducation.vue'
import ProfilePreview from '@/views/userProfile/ProfilePreview.vue'
import { ROLES } from '@/store'

export default {
  path: '/cs/user/:masqueradeUser',
  component: UserProfileLayout,
  meta: {
    requiresAuth: true,
    allowedRoles: [
      ROLES.masqueradingReadOnly,
    ]
  },
  children: [
    {
      path: '/',
      name: 'Masquerade Profile',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: PersonalInfo
    },
    {
      path: 'workeducation',
      name: 'Masquerade Work Education',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: WorkEducation
    },
    {
      path: 'career',
      name: 'Masquerade Career',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: Career
    },
    {
      path: 'achievement',
      name: 'Masquerade Achievement',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: Achievement
    },
    {
      path: 'visibility',
      name: 'Masquerade Profile Visibility',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'profile'
      },
      component: ProfileVisibility
    },
    {
      path: 'security',
      name: 'Masquerade Change Password',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'settings'
      },
      component: Security
    },
    {
      path: 'privacy',
      name: 'Masquerade Privacy',
      meta: {
        headerTitlei18n: 'account',
        navSectioni18n: 'settings'
      },
      component: Privacy
    },
    {
      path: 'preview',
      name: 'Masquerade Profile Preview',
      meta: {
        headerTitlei18n: 'profilePreview'
      },
      component: ProfilePreview
    }
  ]
} as RouteConfig
